import React, { memo } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { BackArrow } from './components/BackArrow';
import { MainContent } from './components/MainContent';
import { ButtonsBlock } from './components/ButtonsBlock';

// Styles
import styles from './styles.pcss';
const cn = classNames.bind(styles);

export const ErrorDescriptionPopup = memo(({ errorDescriptionData, onBack = () => {}, onClose = () => {} }) => {
  const {
    header, message, buttons, image, arrowText,
  } = errorDescriptionData || {};
  return (
    <div className={cn('error')}>
      {arrowText && <BackArrow {...{ onBack, arrowText }} />}
      <MainContent {...{ image, header, message }} />
      {!!buttons?.length && <ButtonsBlock {...{ buttons, onClose }} />}
    </div>
  );
});

ErrorDescriptionPopup.propTypes = {
  errorDescriptionData: PropTypes.object,
  onBack: PropTypes.func,
  onClose: PropTypes.func,
};
